export enum ManualPricingCmd {
  START,
  INITIALIZE,
  ACTIVATE,
  ADD,
  UPDATE,
  CLOSE_TAB,
  EXIT,
  UPDATE_WARNING,
  UPDATE_PRICE_BTN,
}

export class ManualPricingCmdPayload {
  public cmd: ManualPricingCmd = null;
  public payload: any = null;

  constructor(command: ManualPricingCmd, payload?: any) {
    this.cmd = command;
    this.payload = payload;
  }
}
